import { api } from './api';

/**
 * 곡 앨범 자켓 주소 (새 디자인 화면용, 2026-10). 화면에 보이는 곡들을 50ms 동안 모아 한 번에 /covers 로 묻는다.
 * 없으면 null (화면은 색 타일 + 제목 첫 글자).
 */
const cache = new Map<number, string | null>();
const waiting = new Map<number, ((url: string | null) => void)[]>();
let timer: any = null;

const flush = async () => {
  timer = null;
  const ids = Array.from(waiting.keys()).slice(0, 200);
  if (!ids.length) return;
  let map: Record<string, string> = {};
  try {
    const { data } = await api.get('/covers', { params: { ids: ids.join(',') } });
    map = (data && data.data) || {};
  } catch (e) {}
  ids.forEach((id) => {
    const url = map[String(id)] || null;
    cache.set(id, url);
    (waiting.get(id) || []).forEach((cb) => cb(url));
    waiting.delete(id);
  });
  if (waiting.size) timer = setTimeout(flush, 50);
};

export const getCover = (id: number): Promise<string | null> => {
  if (cache.has(id)) return Promise.resolve(cache.get(id) as string | null);
  return new Promise((resolve) => {
    const list = waiting.get(id) || [];
    list.push(resolve);
    waiting.set(id, list);
    if (!timer) timer = setTimeout(flush, 50);
  });
};

export const cachedCover = (id: number) => (cache.has(id) ? cache.get(id) : undefined);
